const SUBSCRIPT_DIGITS = "₀₁₂₃₄₅₆₇₈₉";
const MIN_ZEROS = 4;
const TINY_PRICE = new RegExp(`^(-?0[.,])(0{${MIN_ZEROS},})(\\d+)$`);

const toSubscript = (value: number) =>
  String(value)
    .split("")
    .map((digit) => SUBSCRIPT_DIGITS[Number(digit)])
    .join("");

export const shortZeros = (formatted: string) => {
  const match = TINY_PRICE.exec(formatted);
  if (!match) return formatted;
  const [, head, zeros, digits] = match;
  return `${head}0${toSubscript(zeros.length)}${digits}`;
};
